import { computed, state } from 'ccstate'

const reloadPathname$ = state(0)

const pathname$ = computed((get) => {
  get(reloadPathname$)
  return location.pathname
})

export const sharedLocationState = {
  reloadPathname$,
  pathname$,
}